


















import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component({
})
export default class ProductSort extends Vue {
  @Prop({ type: Array })
  sort!: Array<Sort>

  @Prop({ type: Number })
  selectedSort!: number

  private changeSorting () {
    this.$emit('updateSort', parseInt((this.$refs.sort as HTMLSelectElement).value))
  }
}
